window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');
    window.Popper = require('@popperjs/core');
    window.bootstrap = require('bootstrap');
    window.axios = require("axios");
    window.DataTable = require('datatables.net-bs5')
} catch (e) {
    console.error(e);
}
